<script setup lang="ts"></script>

<template>
  <UserInterfaceGradientBackgroundHolster
    :show-banner="false"
    :full-page="false"
  >
    <template #title>
      <div
        class="text-center py-4 text-base-priority bg-layer-2 max-w-[420px] w-full rounded-t-lg"
      >
        <slot name="title" />
      </div>
    </template>
    <template #component>
      <LazyAuthPostRegCompleteRegistration
        class="max-w-[340px]"
        skip-acknowledgment
      />
    </template>
  </UserInterfaceGradientBackgroundHolster>
</template>

<style scoped lang="scss"></style>
